export default function SvgPay() {
    return (
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          cursor="pointer"
          version="1.1"
          viewBox="0 0 32 32"
          xmlSpace="preserve"
        >
        <g fill="#000">
          <path d="M32 8.5c0-.827-.673-1.5-1.5-1.5H26V1.908c0-.743-.222-1.282-.658-1.603-.486-.355-1.176-.396-2.041-.123L.359 6.883a.493.493 0 00-.345.547C.011 7.454 0 7.475 0 7.5v23c0 .827.673 1.5 1.5 1.5h29c.827 0 1.5-.673 1.5-1.5v-22zM31 24h-9.5a.5.5 0 01-.5-.5v-8a.5.5 0 01.5-.5H31v9zM23.592 1.139c.538-.169.951-.181 1.158-.028.207.152.25.517.25.797V7H3.526l20.066-5.861zM30.5 31h-29a.5.5 0 01-.5-.5V8h29.5a.5.5 0 01.5.5V14h-9.5c-.827 0-1.5.673-1.5 1.5v8c0 .827.673 1.5 1.5 1.5H31v5.5a.5.5 0 01-.5.5z"></path>
          <path d="M25.351 21.605c1.193 0 2.165-.971 2.165-2.164s-.972-2.165-2.165-2.165-2.164.971-2.164 2.165.97 2.164 2.164 2.164zm0-3.328a1.166 1.166 0 010 2.329 1.165 1.165 0 010-2.329z"></path>
        </g>
      </svg>
      </>
    );
  }
  